export type ServiceCategoryCode =
    | 'MAINTENANCE'
    | 'PAINT'
    | 'CLEAN'
    | 'FLOORING'
    | 'ADMIN'

export const SERVICE_CATEGORY_LABELS: Record<ServiceCategoryCode, string> = {
    MAINTENANCE: 'Maintenance',
    PAINT: 'Paint',
    CLEAN: 'Clean',
    FLOORING: 'Flooring',
    ADMIN: 'Admin',
}

export const SERVICE_CATEGORY_ORDER: ServiceCategoryCode[] = [
    'PAINT',
    'CLEAN',
    'FLOORING',
    'MAINTENANCE',
    'ADMIN',
]

export interface Service {
    id: number
    name: string
    color: string
    order: number
    checked?: boolean
    /** Global classification (not apartment-specific). Null/omitted for archived or uncategorized. */
    service_category?: ServiceCategoryCode | null
    /** null = global service; otherwise the apartment ID that owns it. */
    apartment?: number | null
    /** true when apartment is not null (custom/private to one property). */
    is_custom?: boolean
}

/** National catalog only — excludes apartment-owned custom services. */
export const isNationalCatalogService = (service: {
    apartment?: number | null
    is_custom?: boolean
}) => !service.is_custom && service.apartment == null

export interface CreateServiceRequest {
    name: string
    service_category: ServiceCategoryCode
    color?: string
}
